import { useQuery } from "react-query";
import API from "../api/API";
import { useCreateToast } from "./toasts";
import { usePrefetchQuery } from "../hooks/mutations";

const fetchSpots = async () => {
  return await API.spots.getAll().then(
    (result) => result.spots,
    (error) => {
      const createToast = useCreateToast();
      createToast("danger", "Error fetching spots. Please try again");
      console.error(error);
    }
  );
};

export const useSpots = () => {
  return useQuery("spots", fetchSpots);
};

export const usePrefetchSpots = () => usePrefetchQuery("spots", fetchSpots);
